export const IMAGE_RECOGNITION_THRESHOLD = 90;
